<app-modal *ngIf="vo$ | async; let vo" (triggerClose)="close()">
	<div modal-body class="app-depot-creation-content">
		<app-card-outline>
			<h3 card-outline-title i18n="@@general.metadata">metadata</h3>
			<ng-container card-outline-content>
				<app-metadata
					#depotMetadata="Metadata"
					[metadata]="initialMetadata"
					(notifyOnError)="metadataHasError($event)">
					<app-tag-configurator
						[availableTags]="vo.availableTags | toArray"
						configMode="ActiveEdit"></app-tag-configurator>
				</app-metadata>
			</ng-container>

		</app-card-outline>

		<div class="automatic-affectation">
			<mat-label
				i18n="@@depot.subscription.affectationAuto"
				matTooltip="affectation"
				i18n-matTooltip="@@depot.subscription.affectationAutoTooltip">
				affectation-auto</mat-label>
			<mat-slide-toggle
				color="primary"
				id="{{ cmpId }}-affectation-auto"
				[(ngModel)]="allowProducerVersionSwitch"></mat-slide-toggle>
		</div>

		<ng-container *ngIf="vo.subscriptionsList">
			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[itemsCount]="vo.subscriptionsList.elements.size"
				(refresh)="refresh()"
				(search)="search($event)">
				<div panel-title class="app-panel__title">
					<mat-icon [svgIcon]="GdIcons.Connector"></mat-icon>
					<span i18n="@@subscription.list.title">Subscription</span>
				</div>

				<dx-data-grid
					keyExpr="id"
					[elementAttr]="{
							id: 'subscriptions-list',
							class: 'subscription-for-depot-list'
						}"
					[dataSource]="vo.subscriptionsList.elements | toArray"
					[hoverStateEnabled]="true"
					[showColumnHeaders]="true"
					[allowColumnResizing]="true"
					[columnAutoWidth]="false"
					[showRowLines]="false"
					[showColumnLines]="false"
					[rowAlternationEnabled]="false"
					[showBorders]="false"
					[width]="'100%'"
					(onSelectionChanged)="onSelection($event)"
					(onContentReady)="onGridContentReady()">
					<dxo-selection mode="single"></dxo-selection>
					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="vo.isFirstLoad"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<!-- Fixable in position columns	-->
					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<dxo-scrolling mode="virtual"></dxo-scrolling>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Pagination -->
					<dxo-paging [pageSize]="1000"></dxo-paging>

					<dxo-pager [visible]="false"></dxo-pager>

					<!-- Filterable columns	-->
					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-filter-row [visible]="true"></dxo-filter-row>

					<ng-container *ngFor="let col of vo.subscriptionsList.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'label'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[dataType]="col.type"
							[format]="col.format"
							[alignment]="'left'"
							[width]="'20%'"
							[visibleIndex]="col.visibleIndex"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'projectVersion'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[dataType]="col.type"
							[format]="col.format"
							[alignment]="'left'"
							[width]="'10%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="projectVersionTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'description'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable ?? false"
							[allowSorting]="true"
							[dataType]="col.type"
							[format]="col.format"
							[alignment]="'left'"
							[width]="'40%'"
							[visibleIndex]="col.visibleIndex"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'keywords'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable ?? false"
							[allowSorting]="true"
							[dataType]="col.type"
							[format]="col.format"
							[alignment]="'left'"
							[width]="'30%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="keywordsTemplate"></dxi-column>
					</ng-container>

					<div
						*dxTemplate="let cell of 'keywordsTemplate'">
						<app-tag-configurator
							configMode="View"
							displayMode="keywords"
							[configuredTags]="cell.data['keywords']"></app-tag-configurator>
					</div>

					<div *dxTemplate="let cell of 'projectVersionTemplate'">
						<div class="version-badge">
							<span>{{cell.data['projectVersion']}}</span>
						</div>
					</div>
				</dx-data-grid>
			</app-panel>
		</ng-container>
	</div>

	<div modal-footer class="app-depot-creation__footer">
		<button
			id="{{ cmpId }}-create-btn"
			mat-raised-button
			[disabled]="!vo.isMetadataValid ||
			depotMetadata.metadataFormValues === null ||
			!vo.hasSelection"
			(click)="createSubscriptionForRepo(depotMetadata.metadataFormValues)"
			color="primary">
			<span class="app-depot-creation__footer-btn">
				<mat-icon
					*ngIf="!vo.isCreationInProgress"
					[svgIcon]="DcIcons.Save"></mat-icon>
				<mat-icon *ngIf="vo.isCreationInProgress">
					<mat-spinner color="accent" [diameter]="20"></mat-spinner>
				</mat-icon>
				<span i18n="@@general.stepper.create">Create</span>
			</span>
		</button>
	</div>
</app-modal>
